import { parseCheckoutAttemptResult, type CheckoutAttemptResult } from './checkoutLifecycleContract';
import { supabase, toError } from './supabase';

function unwrapRpcValue(value: unknown): unknown {
    return Array.isArray(value) && value.length === 1 ? value[0] : value;
}

export async function getCheckoutAttemptResult(
    checkoutAttemptId: string,
): Promise<CheckoutAttemptResult> {
    const { data, error } = await (supabase as any).rpc(
        'get_run5_checkout_attempt_result',
        { p_checkout_attempt_id: checkoutAttemptId },
    );
    if (error) throw toError(error);
    return parseCheckoutAttemptResult(unwrapRpcValue(data));
}

export async function getCheckoutAttemptResultBySession(
    checkoutSessionId: string,
): Promise<CheckoutAttemptResult> {
    const { data, error } = await (supabase as any).rpc(
        'get_run5_checkout_attempt_result_by_session',
        { p_checkout_session_id: checkoutSessionId },
    );
    if (error) throw toError(error);
    return parseCheckoutAttemptResult(unwrapRpcValue(data));
}

async function recordCheckoutAttemptSignal(
    rpcName: 'record_run5_checkout_form_ready' | 'record_run5_checkout_cancelled',
    checkoutAttemptId: string,
): Promise<void> {
    const { error } = await (supabase as any).rpc(
        rpcName,
        { p_checkout_attempt_id: checkoutAttemptId },
    );
    if (error) throw toError(error);
}

export async function recordCheckoutFormReady(checkoutAttemptId: string): Promise<void> {
    await recordCheckoutAttemptSignal('record_run5_checkout_form_ready', checkoutAttemptId);
}

export async function recordCheckoutCancelReturn(checkoutAttemptId: string): Promise<void> {
    await recordCheckoutAttemptSignal('record_run5_checkout_cancelled', checkoutAttemptId);
}
